<script setup>
import { useStore } from 'vuex'
import { computed, ref } from 'vue'
import WaterLineChart from '@/components/water-line/WaterLineChart.vue'

const store = useStore()

const waterLineChart = ref(null)

const currentStabSchematisationStage = computed(
  () => store.state.stabSchematisationStage.currentItem
)

const topoPlotData = computed(() => store.getters['topoProfilePoint/getPlotData'])
const soilLayerPlotData = computed(() => store.getters['soilLayer/getPlotData'])
const headLinePlotData = computed(() => store.getters['headLine/getPlotData'])
const headReferenceLinePlotData = computed(() => store.getters['headReferenceLine/getPlotData'])
const getBurstCalculationPlotData = computed(
  () => store.getters['multipleHeadLine/getBurstCalculationPlotData']
)
const refPlot = computed(() => `head-line-${currentStabSchematisationStage.value.id}`)

const headLineCombinePlotData = computed(() => [
  ...soilLayerPlotData.value(),
  ...topoPlotData.value(),
  ...headLinePlotData.value(),
  ...headReferenceLinePlotData.value(),
  ...getBurstCalculationPlotData.value
])

const emit = defineEmits(['clickPoint'])

defineExpose({
  waterLineChart
})
</script>
<template>
  <WaterLineChart
    :data-chart="headLineCombinePlotData"
    :refPlot="refPlot"
    ref="waterLineChart"
    @clickPoint="(e) => emit('clickPoint', e)"
  ></WaterLineChart>
</template>
